import { ArrowUpRight, BadgeCheck } from "lucide-react";
import { useNotify, useTranslate, useUpdate } from "ra-core";
import { Link, useNavigate } from "react-router";

import { Button } from "@/components/ui/button";
import type { Company } from "../types";

// Shown on a company page (admins only reach it): turns a prospect into a
// client, or links to the client profile once it already is one.
export const ConvertToClientButton = ({ company }: { company: Company }) => {
  const translate = useTranslate();
  const notify = useNotify();
  const navigate = useNavigate();
  const [update, { isPending }] = useUpdate();

  if (company.is_client) {
    return (
      <Link
        to={`/clients/${company.id}/show`}
        className="flex items-center gap-1.5 rounded-full bg-primary/15 px-4 py-2 text-sm font-semibold text-primary no-underline hover:bg-primary/25"
      >
        <BadgeCheck className="size-4" />
        {translate("resources.clients.action.view_profile")}
        <ArrowUpRight className="size-4" />
      </Link>
    );
  }

  const handleConvert = () => {
    update(
      "companies",
      {
        id: company.id,
        data: {
          is_client: true,
          client_since: new Date().toISOString().slice(0, 10),
        },
        previousData: company,
      },
      {
        mutationMode: "pessimistic",
        onSuccess: () => {
          notify("resources.clients.action.converted", { type: "success" });
          navigate(`/clients/${company.id}`);
        },
        onError: () => notify("ra.notification.http_error", { type: "error" }),
      },
    );
  };

  return (
    <Button
      className="rounded-full"
      onClick={handleConvert}
      disabled={isPending}
    >
      <BadgeCheck className="size-4" />
      {translate("resources.clients.action.convert")}
    </Button>
  );
};
